<template>
  <div class="marketing-materials">
    <div class="block">
      <h2>Marketing Materials</h2>

      <div class="subsections">
        <template v-if="isEditing">
          <DemoData
            v-if="isEditingDemoData"
            @cancel="onDemoDataCancel"
          />

          <MarketingMaterialsThemes
            v-if="isEditingTheme"
            @cancel="onManageThemeCancel"
          />
        </template>

        <template v-else>
          <div class="subsection-switch-btns">
            <b-button
              class="modern-button is-success subsection-switch-btn"
              @click="onDemoDataClick"
            >
              demo data
            </b-button>

            <b-button
              class="modern-button is-success subsection-switch-btn"
              @click="onManageThemeClick"
            >
              manage theme
            </b-button>
          </div>
        </template>
      </div>
    </div>

    <div>
      <div class="tabs">
        <div
          v-for="tab in tabs"
          :key="tab.id"
          role="button"
          class="tab"
          :class="tab.id === activeTab ? 'is-active' : ''"
          @click="() => activateTab(tab.id)"
        >
          {{ tab.displayName }}
        </div>
      </div>

      <component
        v-for="tab in tabs"
        :key="tab.id"
        :is="tab.component"
        :is-active="tab.id === activeTab"
      />
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import {
  MARKETING_MATERIALS_MANAGE_MODIFY,
} from '@/const/privileges';
import SocialMediaImages from './SocialMediaImageTemplate/SocialMediaImages.vue';
import Flyer from './components/Flyer.vue';
import DemoData from './components/DemoData.vue';
import MarketingMaterialsThemes from './MarketingMaterialsTheme/MarketingMaterialsThemes.vue';
import Banners from './Banner/Banners.vue';

const TAB_FLYER = 'Flyer';
const TAB_SOCIAL_MEDIA_IMAGES = 'Social media images';
const TAB_BANNERS = 'Banners';

export default {
  name: 'MarketingMaterials',
  components: {
    Banners,
    MarketingMaterialsThemes,
    DemoData,
    Flyer,
    SocialMediaImages,
  },

  data() {
    return {
      MARKETING_MATERIALS_MANAGE_MODIFY,
      activeTab: TAB_FLYER,
      isEditingDemoData: false,
      isEditingTheme: false,
      tabs: [
        {
          id: TAB_FLYER,
          displayName: 'Flyer',
          component: Flyer,
        },
        {
          id: TAB_SOCIAL_MEDIA_IMAGES,
          displayName: 'Social Media Images',
          component: SocialMediaImages,
        },
        {
          id: TAB_BANNERS,
          displayName: 'Banners',
          component: Banners,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['hasAccess']),
    isEditing() {
      return this.isEditingTheme || this.isEditingDemoData;
    },
  },

  methods: {
    activateTab(id) {
      this.activeTab = id;
    },
    onDemoDataClick() {
      this.isEditingDemoData = true;
    },
    onManageThemeClick() {
      this.isEditingTheme = true;
    },
    onDemoDataCancel() {
      this.isEditingDemoData = false;
    },
    onManageThemeCancel() {
      this.isEditingTheme = false;
    },
  },
};
</script>

<style lang="stylus">
.settings .marketing-materials
  & .subsections
    margin-bottom 3rem
  & .subsection-switch-btns
    display flex
    gap 1rem
    & .subsection-switch-btn
      min-width 150px
</style>

<style lang="stylus" scoped>
@media screen and (min-width: 768px)
  .column-template-selector
    min-width 450px
button.button
  min-width: 110px;
  text-transform uppercase

.buttons-alignment
  justify-content right

.tabs
  display flex
  justify-content start
  border-bottom 1px solid rgba(143, 167, 179, 0.3)
  overflow visible
  .tab
    cursor pointer
    margin 0 15px
    padding-bottom: 18px
    &:first-child
      margin: 0 15px 0 0
    &.is-active
      position relative
      font-weight 600
      &:after
        content: ''
        position absolute
        bottom -1.5px
        left 0
        width 100%
        height 3px
        background rgba(23, 181, 72, 1)
</style>
